import { Typography } from "antd";

const { Title, Text } = Typography;

interface ComingSoonTabProps {
	title: string;
}

export function ComingSoonTab({ title }: ComingSoonTabProps) {
	return (
		<div className="flex flex-col items-center justify-center py-16 text-gray-400">
			<Title level={5} className="text-gray-400!">
				{title}
			</Title>
			<Text type="secondary">Bu bo'lim tez orada ishga tushiriladi</Text>
		</div>
	);
}
